
function generateFAQSchema() {


    // Check if `faqData` is available globally (via wp_localize_script)
    if (typeof faqData !== 'undefined' && Array.isArray(faqData)) {
        const pageTitle = document.title || 'FAQ';
		// console.log(faqData);
        // Generate the FAQ Schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": 'FAQPage', // Set type dynamically based on page context
			"@id": window.location.href + "#faq", // Use the page URL as a unique ID
            "name": pageTitle,  // Add a name based on page title
            "mainEntity": faqData.map((faq) => ({
                "@type": "Question",
                "name": faq.question.replace(/<\/?[^>]+(>|$)/g, ""),
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": faq.answer.replace(/<\/?[^>]+(>|$)/g, ""),
                },
            })),
        };

        // Create a <script> tag for the schema
        const schemaScript = document.createElement("script");
        schemaScript.type = "application/ld+json";
        schemaScript.textContent = JSON.stringify(faqSchema, null, 2);

        // Append it to the <head> of the document
        document.head.appendChild(schemaScript);

        console.log("FAQ schema generated and added to <head>.");
    } else {
        // console.log("faqData is not defined or is not an array. Check your wp_localize_script setup.");
    }
}
generateFAQSchema();
